import React, { useCallback, useEffect, useRef, useState } from "react";
import { useInformations } from "../../../hooks/useInformations";
import { useName } from "../../../hooks/useName";
import { useMask } from "../../../hooks/useMask";

import { IHTMLInputElement, IInput } from "../../../interfaces/input";
import { IStatus } from "../../../interfaces/status";

import { Checkbox } from "../Checkbox";
import { Datetime } from "../Datetime";
import { Password } from "../Password";
import { Search } from "../Search";
import { Tel } from "../Tel";

import { Informations } from "../../Informations";

import { Input as InputEl, Container } from "./styles";

export const Input: React.FC<IInput> = (props) => {
  const types = {
    checkbox: <Checkbox {...props} />,
    date: <Datetime {...props} />,
    password: <Password {...props} />,
    search: <Search {...props} />,
    tel: <Tel {...props} />,
  };

  const customTypes: string[] = [];
  for (var [key] of Object.entries(types)) {
    customTypes.push(key);
  }

  if (props.type && customTypes.includes(props.type)) {
    return types[props.type];
  }

  const { name } = useName(props.name);

  const [value, setValue] = useState<string | number>();

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { name, value, type } = event.currentTarget;

    let nextValue: string | number = value;

    if (type === "number") {
      nextValue = Number(value);
    }

    setValue(nextValue);

    props.onChange && props.onChange(name, nextValue, event);
  };

  const [status, setStatus] = useState<IStatus>("VALIDATED");

  const validate = useCallback(() => {
    if (
      props.required &&
      (typeof value === "undefined" || value === null || value === "")
    ) {
      setStatus("ERROR_REQUIRED");
      return;
    }

    if (props.type === "email" && !/^\S+@\S+$/.test(value as string)) {
      setStatus("ERROR_EMAIL-INVALID");
      return;
    }

    setStatus("VALIDATED");
  }, [props.required, value]);

  useEffect(() => {
    validate();
  }, [validate]);

  const informationsRef = useRef(null);

  const {
    informations,
    onValidate: onValidateInformations,
    getInformationsClasses,
  } = useInformations({
    ref: informationsRef,
    inputProps: props,
  });

  const onValidate: React.FocusEventHandler<HTMLElement> = (event) => {
    if (props.mask) {
      const { value } = event.currentTarget as HTMLInputElement;

      setValue(value);

      props.onChange && props.onChange(name, value, event);
    }

    onValidateInformations(event);
  };

  const myRef = useRef(null);

  const { mask } = useMask();

  useEffect(() => {
    if (!props.mask) return;

    mask(myRef.current!, props.mask);
  }, [props.mask]);

  return (
    <Container className="input-container">
      <InputEl
        {...{
          ...(props as IHTMLInputElement),
          name,
          value,
          autoComplete: "chrome-off",
          type: props.type,
          onChange,
          "data-status": status,
          onBlur: onValidate,
          className: getInformationsClasses(),
          "data-input": "input",
          ref: myRef,
          disabled: props.disabled,
          placeholder: props.placeholder,
        }}
      />
      <Informations {...{ name, ref: informationsRef, ...informations }} />
    </Container>
  );
};
